export default __webpack_public_path__ + "static/media/information--park-and-ride--g1.b750a298.png";